let ids = 0;

export function getUid(): string {
    return (++ids).toString();
}